<template>
  <el-dialog v-dialogDrag title="选择系统角色" :visible.sync="dlgVisible" width="500px">
    <system-role ref="systemRole" :userList="[]" @updateRight="selectedSysRoleChanged"></system-role>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dlgVisible = false">取 消</el-button>
      <el-button v-preventReClick type="primary" size="small" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SystemRole from '@/CommonDP/components/chooseMember/component/SystemRole.vue';
import priviService from '@/CommonDP/service/privi-service';
import { mapState } from "vuex";

export default {
  components: { SystemRole },
  props: {
    type: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      dlgVisible: false,
      fromRoleId: "",
      selectedRoleIds: [],
      prjRoleId: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  methods: {
    showDlg(fromRoleId, prjRoleId) {
      this.fromRoleId = fromRoleId;
      this.prjRoleId = prjRoleId;
      this.selectedRoleIds = [];
      this.dlgVisible = true;
      this.$nextTick(() => {
        this.$refs.systemRole.filterTextSys = '';
      });
    },
    selectedSysRoleChanged(type, roleList) {
      this.selectedRoleIds = roleList.map(item => item.roleID);
    },

    async submit() {
      if (!this.selectedRoleIds.length) {
        this.$error("请勾选目标角色");
        return;
      }
      // this.$warn("正在提交");
      console.debug("准备提交数据：", this.selectedRoleIds);
      if (this.type === 'allprjPrivi') {
        const { fromRoleId, enterpriseId, selectedRoleIds, prjRoleId } = this;
        const params = {
          enterpriseId,
          roleIdList: selectedRoleIds,
          managerType: fromRoleId,
          prjRoleId
        };
        await priviService.prjManagerAddSysRole(params);
        this.$emit('ok');
      } else {
        const json = { fromRoleId: this.fromRoleId, toRoleIds: this.selectedRoleIds };
        await priviService.copyPermissionsFromRoleToOthers(json);
      }
      this.$success("操作成功");
      this.dlgVisible = false;
    }
  }

};
</script>

<style></style>
